export const cookieStore = {
  namespaced: true,
  state: () => ({
    accepted: null
  }),
  actions: {
    accept (context) {
      context.commit('accept')
    },
    decline (context) {
      context.commit('decline')
    }
  },
  mutations: {
    accept (state) {
      state.accepted = true
    },
    decline (state) {
      state.accepted = false
    }
  },
  getters: {
    isVisible: state => state.accepted === null
  }
}
